import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useNavStack } from "./ScrollToTop";

const LABELS = [
  ["/products/", "al prodotto"], ["/shops/", "alla vetrina"], ["/s/", "alla vetrina"], ["/shops", "ai fioristi"],
  ["/cart", "al carrello"], ["/checkout", "al checkout"], ["/catalogo", "al catalogo"], ["/momenti/", "al momento"],
  ["/dashboard", "alla dashboard"], ["/admin", "alla supervisione"], ["/my-orders", "ai tuoi ordini"], ["/ricorrenze", "alle ricorrenze"],
  ["/account", "al tuo account"], ["/blog", "al blog"], ["/login", "all'accesso"], ["/register", "alla registrazione"],
  ["/trova-il-gesto-giusto", "alla guida"], ["/fiori-a-domicilio", "ai fiori a domicilio"], ["/fiori-a-", "alla pagina città"], ["/traccia/", "al tracciamento"],
];
const labelFor = (path) => (path === "/" ? "alla home" : LABELS.find(([p]) => path.startsWith(p))?.[1] || "indietro");

export const BackButton = () => {
  const stack = useNavStack();
  const navigate = useNavigate();
  if (stack.length < 2) return null;
  const prev = stack[stack.length - 2];
  return (
    <button
      type="button"
      onClick={() => navigate(-1)}
      aria-label={`Torna ${labelFor(prev.path)}`}
      title={`Torna ${labelFor(prev.path)}`}
      data-testid="back-button"
      className="fixed bottom-5 left-4 sm:left-6 z-[45] group flex items-center gap-2 h-12 pl-3 pr-3 md:pr-4 rounded-full bg-forest text-white shadow-lg shadow-forest/30 hover:bg-forest/90 hover:-translate-x-0.5 active:scale-95 transition-[transform,background-color] duration-200 animate-in fade-in slide-in-from-left-4"
    >
      <span className="h-6 w-6 rounded-full bg-white/15 flex items-center justify-center shrink-0">
        <ArrowLeft className="h-4 w-4" />
      </span>
      <span className="hidden md:inline text-sm font-medium" data-testid="back-button-label">Torna {labelFor(prev.path)}</span>
    </button>
  );
};
